import MapPage from './components/map-page';

export default MapPage;
